import { Permission, usePermissions } from './'

export const useCheckPermissions = (permissions: Permission[]) => {
  const { allowed } = usePermissions()

  return allowed(permissions)
}
